const daysOfWeek = {
  'sun': 'Sunday',
  'mon': 'Monday',
  'tue': 'Tuesday',
  'wed': 'Wednesday',
  'thu': 'Thursday',
  'fri': 'Friday',
  'sat': 'Saturday'
}

export default (context, inject) => {
  const utils = {
    // import: (path) => {
    //   if(!path.match(/\.vue$/)) {
    //     path += '.vue'
    //   }
    //   utils.log(path)
    //   return () => import(`${process.env.TEST_LIB ? '~' : '@pleinair/bigcolony-vue'}/components/${path}`)
    // },
    log: (...any) => {
      if (process.env.GW_ENV && process.env.GW_ENV !== 'prod') {
        console.log(...any)
      }
    },
    copy: (obj) => {
      return JSON.parse(JSON.stringify(obj))
    },
    delay: (ms = 1000) => {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    urlify: (...text) => {
      let parts = text.map(t => {
        return t.toLowerCase().replace(/\s/g, '-').replace(/\,\./g, '').trim()
      })
      return parts.join('/')
    },
    remainingBalance: () => {
      if (context.store.state.cart && context.store.state.cart.totals && context.store.state.cart.totals.total) {
        let total = context.store.state.cart.totals.total
        context.store.state.checkout.giftcards.map(g => {
          total -= g.balance
        })
        return total <= 0 ? false : true
      } else {
        return true
      }
    },
    content: async (path) => {
      if (process.server) {
        return await context.$backend.content(path)
      } else {
        if (!path) {
          // We should avoid hitting Storyblok directly. There are API limits we need to be aware of.
          console.error('** path should not be empty')
          return
        }

        return await context.$axios({
          method: 'get',
          url: `v2/content?path=${path}${process.env.DRAFT_CONTENT ? '&version=draft' : ''}`
        })
          .then(res => {
            return res.data
          })
          .catch(err => {
            return null
          })
      }
    },
    folder: async (directory, numberOfItems = 25) => {
      if (process.server) {
        return await context.$backend.listFiles(directory)
      } else if (process.env.NODE_ENV === 'development') {
        const info = await context.$axios({
          method: 'get',
          url: 'v2/content/filter',
          params: {
            starts_with: directory,
            per_page: numberOfItems,
            version: process.env.DRAFT_CONTENT === true ? 'draft' : 'published'
          }
        })
          .then(res => {
            return res.data
          })
          .catch(err => {
            return null
          })

        return info.stories.map(s => {
          const body = []
          if (s.content && s.content.body && s.content.body[0]) {
            body.push({
              _uid: s.content.body[0]._uid || '',
              title: s.content.body[0].title || '',
              text: s.content.body[0].text || '',
              slug: s.content.body[0].slug || '',
              image: s.content.body[0].image || {},
              date: s.content.body[0].date || '',
              component: s.content.body[0].component || '',
            })
          }

          return {
            slug: s.slug,
            full_slug: s.full_slug,
            name: s.name,
            content: {
              meta_description: s.content.meta_description || '',
              meta_image: s.content.meta_image || '',
              meta_title: s.content.meta_title || '',
              title: s.content.title || '',
              image: s.content.image || {},
              body: body,
            },
          }
        })
      } else {
        const info = await context.$axios({method:'get', url: '/info.json'})
        if (info && info.data && info.data.sitemap) {
          const instances = []
          info.data.sitemap.map(u => {
            if (u.uri.startsWith(directory)) {
              instances.push(u)
            }
          })
          return instances
        }
        return []
      }
    },
    location: (...params) => {
      let route = params.join('/')
      let location = null
      context.store.state.locations.all.map(s => {
        s.cities.map(c => {
          let loc = c.locations.find(l => l.path === route)
          if (loc) {
            location = loc
          }
        })
      })
      return location
    },
    head: (page = {}, options = [], scripts = []) => {
      // page might be null
      if (!page) {
        return {}
      }

      page = page || {}
      let pageTitle = page.name || context.store.state.appInfo.name
      let pageDescription = page.description || context.store.state.appInfo.description
      let pageImage = page.image || context.store.state.appInfo.image

      if (page.content) {
        pageTitle = page.content.meta_title || pageTitle
        pageDescription = page.content.meta_description || pageDescription
        pageImage = page.content.meta_image && page.content.meta_image.filename ? page.content.meta_image.filename : typeof(page.content.meta_image) === 'string' ? page.content.meta_image : pageImage
        if (pageImage && typeof pageImage === 'string') {
          pageImage = pageImage.startsWith('//') ? `https:${pageImage}` : pageImage
        }
      }

      const pageHead = {
        meta: [],
        link: [{
          rel: 'canonical',
          href: `${process.env.BASE_URL}${context.route.path}${context.route.path.match(/\/$/) ? '' : '/'}`
        }],
        script: []
      }

      pageHead.meta.push({
        hid: 'og:type',
        name: 'og:type',
        content: 'website'
      })

      if (pageTitle) {
        pageHead.title = pageTitle
        pageHead.meta.push({
          hid: 'og:title',
          name: 'og:title',
          content: pageTitle
        })
      }

      if (pageDescription) {
        pageHead.meta.push({
          hid: 'description',
          name: 'description',
          content: pageDescription
        })
        pageHead.meta.push({
          hid: 'og:description',
          name: 'og:description',
          content: pageDescription
        })
      }

      if (pageImage) {
        pageHead.meta.push({
          hid: 'og:image',
          name: 'og:image',
          content: pageImage
        })
      }

      if (page.product) {
        // TODO: map product data to data structure
        // pageHead.script.push({
        //   type: 'application/ld+json',
        //   json: {
        //     '@context': 'https://schema.org',
        //     '@type': 'Product',
        //     '@id': `${process.env.BASE_URL}`,
        //     url: `${process.env.BASE_URL}${context.route.path}`,
        //     name: page.name,
        //     description: page.content.description,
        //     sku: page.content.sku,
        //     image: page.content.image,
        //     productID: page.content.sku
        //   }
        // })
      } else if (page.location) {
        let locData = {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            name: page.location.name,
            // image: page.content.image,
            '@id': `${process.env.BASE_URL}`,
            url: `${process.env.BASE_URL}${context.route.path}`,
            telephone: page.location.phone,
            address: {
              '@type': 'PostalAddress',
              streetAddress: page.location.address,
              addressLocality: page.location.city,
              addressRegion: page.location.state,
              postalCode: page.location.zip,
              addressCountry: page.location.country
            }
          }
        }
        if (page.location.hours) {
          locData.json.openingHoursSpecification = []
          page.location.hours.map(d => {
            let dayOfWeek = {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: daysOfWeek[d.day]
            }
            if (d.open !== d.close) {
              dayOfWeek.opens = d.open
              dayOfWeek.closes = d.close
            }
            locData.json.openingHoursSpecification.push(dayOfWeek)
          })
        }
        pageHead.script.push(locData)
      }

      if (options.indexOf('webview') > -1) {
        pageHead.meta.push({
          hid: 'viewport',
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, user-scalable=no'
        })
      }

      scripts.map(s => {
        pageHead.script.push(s)
      })

      return pageHead
    },
    locationHandoffModes: (loc, apphandoffModes = []) => {
      return apphandoffModes.reduce((handoffModes, handoff) => {
        if (loc.services[handoff.key]) {
          handoffModes.push(handoff)
        }
        if (handoff.key === 'reservation') {
          handoffModes.push(handoff)
        }
        if (handoff.key === 'annex') {
          handoffModes.push(handoff)
        }

        return handoffModes
      }, [])
    },
    kebab: (str = '') => {
      return str ? str.replace(/&/g, 'and').toLowerCase().split(' ').join('-') : ''
    },
    pascal: (str = '') => {
      const words = str.split(/[^a-zA-Z]/)
      const pascalCaseString = words
        .filter(word => word.length > 0)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
      return pascalCaseString
    },
    capitalize: (str = '') => {
      return str ? str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      : ''
    },
    
    /**
     * Formats a number as a currency string.
     *
     * @param {number|string} [amount=0] - The amount to format.
     * @param {boolean} [omitTrailingZeroes=false] - Whether to omit trailing zeroes.
     * @param {string} [lang='en-US'] - The locale to use for formatting.
     * @param {string} [currency='USD'] - The ISO code of the currency to use.
     * @returns {string} The formatted currency string.
     */
    currency: (amount = 0, omitTrailingZeroes = false, lang='en-US', currency = 'USD') => {
      let formatted = new Intl.NumberFormat(
        lang, { 
          style: 'currency', 
          currency,
      }).format(amount);

      if (omitTrailingZeroes && (formatted.endsWith('.00') || formatted.endsWith(',00'))) {
        return formatted.substring(0, formatted.length - 3);
      }
      return formatted;
    },
    
    shuffleArray: (array = []) => {
      return array.sort(() => Math.random() - 0.5)
    },
    getMostVisibleElement: (els) => {
      const viewportHeight = window.innerHeight
      let max = 0
      let mostVisibleEl = null
      for (const el of Array.from(els)) {
        const rect = el.getBoundingClientRect()
        const height = rect.bottom - rect.top
        const visible = {
          top: rect.top >= 0 && rect.top < viewportHeight,
          bottom: rect.bottom > 0 && rect.bottom < viewportHeight
        }
        let visiblePx = 0
        if (visible.top && visible.bottom) {
          visiblePx = height // Whole element is visible
        } else if (visible.top) {
          visiblePx = viewportHeight - rect.top
        } else if (visible.bottom) {
          visiblePx = rect.bottom
        } else if (height > viewportHeight && rect.top < 0) {
          let absTop = Math.abs( rect.top )
          if (absTop < height) {
            visiblePx = height - absTop // Part of the element is visible
          }
        }
        if (visiblePx > max) {
          max = visiblePx
          mostVisibleEl = el
        }
      }
      return mostVisibleEl
    },
    getAbsoluteBoundingRect: (el) => {
      let doc  = document,
        win  = window,
        body = doc.body,

        // pageXOffset and pageYOffset work everywhere except IE <9.
        offsetX = win.pageXOffset !== undefined ? win.pageXOffset :
            (doc.documentElement || body.parentNode || body).scrollLeft,
        offsetY = win.pageYOffset !== undefined ? win.pageYOffset :
            (doc.documentElement || body.parentNode || body).scrollTop,

        rect = el.getBoundingClientRect()

      if (el !== body) {
        let parent = el.parentNode

        // The element's rect will be affected by the scroll positions of
        // *all* of its scrollable parents, not just the window, so we have
        // to walk up the tree and collect every scroll offset. Good times.
        while (parent !== body && parent !== null) {
          offsetX += parent.scrollLeft
          offsetY += parent.scrollTop
          parent   = parent.parentNode
        }
      }

      return {
        bottom: rect.bottom + offsetY,
        height: rect.height,
        left  : rect.left + offsetX,
        right : rect.right + offsetX,
        top   : rect.top + offsetY,
        width : rect.width
      }
    }
  }

  inject('utils', utils)
  context.$utils = utils
}
